import blazerShirt from "./blazer-shirt";
import blazerSweater from "./blazer-sweater";
import collarShirt from "./collar-sweater";
import hoodie from "./hoodie";
import overall from "./overall";
import shirtCrewNeck from "./shirt-crew-neck";
import shirtScoopNeck from "./shirt-scoop-neck";
import shirtVNeck from "./shirt-v-neck";

export default {
	blazerShirt,
	blazerSweater,
	collarShirt,
	hoodie,
	overall,
	shirtCrewNeck,
	shirtScoopNeck,
	shirtVNeck,
};



// WEBPACK FOOTER //
// ./src/clothes/index.js